// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3r3ni","inner":"Footer_inner__3uHGR","nextIcon":"Footer_nextIcon__3AEEV","innerLeft":"Footer_innerLeft__3-FgL"};